module.exports = __webpack_public_path__ + "static/lower-bg-d9f82c6899eef5ab84dc53aa02245cf8.jpg";